import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-h2text-primary',
  styleUrl: 'legrandav-h2text-primary.css',
  shadow: true,
})
export class LegrandavH2textPrimary {
  @Prop() text: string;

  render() {
    return (
      <Host>
        <h2>{this.text}</h2>
      </Host>
    );
  }
}
